import LicenseTabs from './license-tabs';

const Licenses = () => <LicenseTabs />;

export default Licenses;